import { Formik } from "formik";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { forgotPassword } from "../../api/setting";
import Loader from "../../component/Loader";
import { subdomainSelector } from "../subdomainSlice";

function ForgetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const subdomain = useSelector(subdomainSelector);

  return (
    <section className="pageAnimation">
      <div className="container-fluid">
        <div className="row align-items-center">
        {/* { !subdomain ? (
            <div className="col-sm-12 col-md-5 col-lg-5 order-2 order-md-1">
            <div className="mb-5">
              <img
                src="assets/images/headerlogo.png"
                className="img-fluid"
                alt="logo"
              />
            </div>

          <div className="logo-bg d-none d-md-block">
            <div className="mt-2" >
              <img
                src="assets/images/activity.png"
                className="img-fluid lft-img"
                alt="logo"
              />
            </div>
          </div>
        </div>
        ) : ( */}
          <div
          className="col-sm-12 col-md-5 d-flex flex-column justify-content-between align-items-center text-center text-md-start order-2 order-md-1"
          style={{
            backgroundColor: '#F8FCFF',
            height: '100vh',
            padding: '40px 24px',
            borderRadius: 0,
            position: 'relative',
          }}
        >

  {/* Middle Section with Welcome Text */}
  <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center w-100 mb-4">
  <div className="text-center mb-4 d-flex align-items-center justify-content-center">
                  <img
                    src='assets/images/activity.png'
                    alt="logo"
                   style={{
                      width: 150,
                      height: 100,
                      borderRadius: '0%',
                      marginRight: 16,
                    }}
                    />
                    {/* <h2 style={{
                      fontWeight: 700,
                      fontSize: 28,
                      color: '#333',
                      marginBottom: 15,
                      lineHeight: 1.2
                    }}>
                      Welcome to <br /> BookInClass
                    </h2> */}
          </div>
    <div className="text-center">
      <h3 style={{
        fontWeight: 600,
        fontSize: 24,
        color: '#333',
        marginBottom: '20px'
      }}>
        Welcome to BookInClass
      </h3>
      <div style={{
      position: 'relative',
      maxWidth: '400px',
      width: '100%'
    }}>
      <img
        src="assets/images/image.png"
        alt="illustration"
        className="img-fluid"
        style={{
          maxWidth: '100%',
          height: 'auto'
        }}
      />
    </div>
    </div>
  {/* Bottom Section with Illustration */}
  <div className="w-100 text-center d-flex justify-content-center align-items-center mt-4">
  <p style={{
        fontSize: 18,
        color: '#333',
        lineHeight: 1.6,
        margin: 0,
        maxWidth: '400px'
      }}>
        The smarter way to manage <br />
        classes, bookings, memberships, <br />
        events, and payments — all <br />
        in one place.
      </p>
  </div>
  </div>

          </div>
        {/* )
      } */}
          <div className="col-sm-12 col-md-7 col-lg-7 mr-0 pr-0 order-1 order-md-2" style={{backgroundColor: '#b3e6f9', height:'100vh'}}>
            <div className="form-bg">
              <Formik
                initialValues={{
                  email: "",
                }}
                validationSchema={Yup.object({
                  email: Yup.string()
                    .email("Kindly enter a valid email.")
                    .required("Required"),
                })}
                onSubmit={(values) => {
                  setLoading(true)
                  forgotPassword({
                    email: values.email?.trim()?.toLowerCase(),
                    url_id: subdomain
                  }).then((res) => {
                    setLoading(false)
                    if (res?.code === 1) {
                      navigate(`/otp/${values.email?.trim()?.toLowerCase()}`, {
                        replace: true,
                      });
                      toast.success(res?.message);
                    } else {
                      toast.error(res?.message, { autoClose: false, closeButton: true });
                    }
                  });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form className="form-style" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 text-center mb-4">
                        <img
                          src="assets/images/forgot-password.png"
                          className="img-fluid my-3"
                          alt=""
                        />
                        <h2 className="mdl-ttl">Forgot Password</h2>
                        <p className="mdl-sbttl">
                          Enter your registered email address.
                        </p>
                      </div>
                      <div className="col-sm-12 col-md-12 mb-4">
                        <div className="form-group">
                          <div className="input-container">
                            <input
                              className="form-control pl-5"
                              placeholder="Email Address"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                            />
                            <img
                              src="assets/images/Email-Address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                        {errors.email && touched.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div className="col-sm-12 col-md-12 text-center">
                      {subdomain ? (
                          <button type="submit" className="btn btn-save" disabled={loading} style={{ width: "100%" }}>
                          {loading ? <Loader /> : "Submit"}
                        </button>
                        ) : (
                          <button type="submit" className="btn btn-save" disabled={loading}>
                          {loading ? <Loader /> : "Submit"}
                        </button>
                        )}
                        
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgetPassword;
